var map = {
	"./Al.svg": "aeef",
	"./Carbon.svg": "9bee",
	"./Cr.svg": "dbfa",
	"./Energy.svg": "12c9",
	"./Fe.svg": "f481",
	"./Folder.svg": "7198",
	"./battery-charging.svg": "3253",
	"./fullscreen-exit.svg": "fff3",
	"./fullscreen.svg": "ef91",
	"./icon-search.svg": "cea3",
	"./live-video.svg": "089c",
	"./multi.svg": "c81a",
	"./nav-arrow-right.svg": "164d",
	"./orthogonal-view.svg": "f1c5",
	"./x-lg.svg": "9672"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "10fe";